import './HomeParallaxSection.css';
import './universal.css';
// Parallax Enquiry Section
export default function enquiry({ categories }) {
  return (
    <section className="home-parallax-section">
      <div className="home-parallax-overlay" />
      <div className="home-parallax-content row">
        <div className="home-parallax-left col-9">
          <h2>For any enquiry, get in touch with us today.</h2>
        </div>
        <div className="home-parallax-right col-3">
          <button className="uni-btn">Download Catalogue</button>
          <button className="uni-btn">Enquire Now</button>
        </div>
      </div>
    </section>
  );
}

